module.exports = __webpack_public_path__ + "static/media/schoolclass.d41b5adb.png";